import { Ptag } from "components/core";
import React from "react";
import { newFormatRupees } from "utlis/utils";

function SumInsuredHeaderDetail({ title, value, children, subtitleMinMax, min, max,defaultSumInsured }) {
  return (
    <div>
      <Ptag fontSize="14px" marginBottom="8px">
        {title}
      </Ptag>
      {subtitleMinMax ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "32px",
            marginBottom: 4,
          }}
        >
           <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Ptag fontSize="16px" fontWeight="600" color="#4a4a4a">
            {newFormatRupees(defaultSumInsured)}
            </Ptag>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Ptag fontSize="16px" color="#8a8a8a">
              Min:
            </Ptag>
            <Ptag fontSize="16px" fontWeight="600" color="#4a4a4a">
              {min}
            </Ptag>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Ptag fontSize="16px" color="#8a8a8a">
              Max:
            </Ptag>
            <Ptag fontSize="16px" fontWeight="600" color="#4a4a4a">
              {max}
            </Ptag>
          </div>
        </div>
      ) : children ? (
        children
      ) : (
        <Ptag fontSize="16px" fontWeight="700" color="#4a4a4a">
          {value}
        </Ptag>
      )}
    </div>
  );
}

export default SumInsuredHeaderDetail;
